// App.js
import { lazy, Suspense, useEffect, useState } from 'react';

import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';

import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import "./css/style.css";

import oktaConfig from "./oktaConfig";
import Todo from './jsx/pages/Todo';
import Registration from './jsx/pages/Registration';
import { RequiredAuth } from './SecureRoute';
import EntraRoutes from './jsx/components/Entra/EntraRoutes';
import { RotationContext } from './context/RotationContext';

const SignUp = lazy(() => import('./jsx/pages/Registration'));
const Login = lazy(() => new Promise(resolve => {
  setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
}));

// -------- rotation order based on EntraRoutes paths --------
const DASHBOARD_ORDER = [
  "/",                        // MetroMap (your default route)
  "/HeartbeatDashboard",               // HeartBeatDashboard
  "/dq",    
  "/e1_dq_metrics",
  "/pbi",
  "/aws_airflow_dashboard",
  "/aws_glue_dashboard",
  "/jde_dashboard",
  "/dbt_dashboard",
  "/qlik_dashboard",
  
  // If you want to include the alternate path too, add "/HeartbeatDashboard"
];
// -----------------------------------------------------------


function RotatingNavigator({ order = DASHBOARD_ORDER, intervalMs = 60 * 1000, enabled = true }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!enabled || order.length === 0) return;

    
    const currentIdx = Math.max(0, order.indexOf(location.pathname));
    const id = setInterval(() => {
      const nextIdx = (currentIdx + 1) % order.length;
      navigate(order[nextIdx], { replace: true });
    }, intervalMs);

    
    return () => clearInterval(id);
  }, [location.pathname, navigate, order, intervalMs, enabled]);

  return null;
}

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }
  return ComponentWithRouterProp;
}

function App(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [rotationEnabled, setRotationEnabled] = useState(false);

  const toggleRotation = () => setRotationEnabled(prev => !prev);

  return (
    <RotationContext.Provider value={{ enabled: rotationEnabled, toggle: toggleRotation }}>
      <div className="vh-100">
        <RotatingNavigator intervalMs={45 * 1000} enabled={rotationEnabled} />
        <EntraRoutes />
      </div>
    </RotationContext.Provider>
  );
}

const mapStateToProps = (state) => {
  console.log("GLOBAL STATE PROPS IN APP JS");
  console.log(state);
  return { isAuthenticated: isAuthenticated(true) };
};

export default App;
